const ButtonArrow = () => <span className="arr inline-block transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5">↗</span>;

export default ButtonArrow;
